import { h } from 'preact';
import PropTypes from 'prop-types';

const Space = ({ rows }) => (
  <span className={`space space--${rows}rows`}/>
);

export default Space;

Space.defaultProps = {
  rows: '1',
};

Space.propTypes = {
  rows: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Steps/General/Space.jsx